import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const UserManagement = React.lazy(async () => ({
    default: (await import('@oc/user-management/module')).UserManagementModule
}))

export function UserManagementComponent() {
    return <SuspenseWhileLoading LazyComponent={UserManagement} />
}

const Settings = React.lazy(async () => ({default: (await import('@oc/user-management/module')).SettingsModule}))

export function SettingsComponent() {
    return <SuspenseWhileLoading LazyComponent={Settings} />
}
